

















import { listFactory } from '@/main/pages';
import { NAME } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, getCurrentLanguageId } from '@/main/utils/commonFunctions';

export default listFactory(NAME, store).extend({	
	computed: {
	isMultipleWorkshopSelected(): boolean {
		return isMultipleWorkshopSelected(this.WorkshopIds);
	},
	searchButtonLabelKey(): string {
		return getSearchButtonLabel(this.WorkshopIds);
	},
	},
	
	methods:{
		async exportFun() {
			try{	
				if (this.filter.WorkshopIds == null || this.filter.WorkshopIds.length === 0) {
				this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
				return;
}
				const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);			
				this.startLoading();

				if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {
					await apiProvider.GetAppointmentListReport(this.WorkshopIds, new Date(this.AppointmentDateFrom!).toISOString(), new Date(this.AppointmentDateTo!).toISOString(), columnsSeq);

				}
			}
			finally{
				this.endLoading();
		    }
		},
		async filterClick() {
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.WorkshopIds,
				(columnsSeq) => ({
					WorkshopIds: this.WorkshopIds,
					AppointmentDateFrom: this.AppointmentDateFrom ? new Date(this.AppointmentDateFrom).toISOString() : this.AppointmentDateFrom,
					AppointmentDateTo: this.AppointmentDateTo ? new Date(this.AppointmentDateTo).toISOString() : this.AppointmentDateTo,
					ColumnSequence: columnsSeq.join(','),
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		}
	},
});
